import Api from '@/services/Api'
import LocalStorage from '@/services/LocalStorageService'

const root = () => `${LocalStorage.getClientPrefix()}/monitoringprocess`

class MonitoringLegacyService {
  findAllJobIdentifiers (processType) {
    const params = { processType }
    return Api().get(`${root()}/findAllJobIdentifiers`, { params })
  }

  findAllDates (processType, jobIdentifier) {
    const params = { processType, jobIdentifier }
    return Api().get(`${root()}/findAllDates`, { params })
  }

  findAll (processType, jobIdentifier, date, page, rows) {
    const params = { processType, jobIdentifier, date, page, rows }
    return Api().get(root(), { params })
  }

  readProcess (processType, jobIdentifier, date, id) {
    const params = { processType, jobIdentifier, date, id }
    return Api().get(`${root()}/readProcess`, { params })
  }
}

export default new MonitoringLegacyService()
